import type { Profile } from '../../models/profile';

export interface PermissionProfileState {
  profile: Profile;
  error: string | null;
  loading: boolean;
}

export const INITIAL_PERMISSION_STATE: PermissionProfileState = {
  profile: {
    id: null,
    userName: '',
    email: '',
    phoneNumber: '',
    nationality: '',
    dateOfBirth: '',
    profilePicture: '',
    driverType: '',
    drivingLicenseNumber: '',
    nationalId: '',
    role: '',
    roleId: null,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Role: { roleName: '' },
    assignmentStatus: '',
    kycStatus: '',
    status: '',
    isAvailable: false,
    isVerified: false,
    preferredLanguage: '',
    notificationPreference: { sms: false, email: false, whatsapp: false },
    documents: [
      {
        documentName: '',
        filePath: '',
        isAdditional: false,
        status: '',
        type: '',
      },
    ],
    otp: '',
    otpExpiry: '',
    resetPasswordToken: '',
    resetTokenExpiry: '',
    createdAt: '',
    updatedAt: '',
  },
  error: null,
  loading: false,
};
